module.exports = __webpack_public_path__ + "img/z18.24614dd1.png";